import axios from 'axios';

export default {
  namespaced: true,
  state: {
    all: [],
  },
  getters: {},
  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'oil-coolers')
        .then(({ data }) => {
          commit('setOilCooler', data);

          if(data.length > 0) commit('build/setOilCooler', data[0].id, { root: true });
        });
    },
  },
  mutations: {
    setOilCooler(state, oilCooler) {
      state.all = oilCooler;
    },
  },
};
